module.exports = __webpack_public_path__ + "img/bank-asiento.11afd0f6.svg";